import React from 'react'

export const IconClock = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="currentColor" viewBox="0 0 100 100" {...props}>
      <path d="M50 5.5C25.463 5.5 5.5 25.463 5.5 50S25.463 94.5 50 94.5 94.5 74.537 94.5 50 74.537 5.5 50 5.5zm0 84c-21.78 0-39.5-17.72-39.5-39.5S28.22 10.5 50 10.5 89.5 28.22 89.5 50 71.78 89.5 50 89.5zm2.5-70.666h-5v32.23l17.935 17.24 3.465-3.606-16.4-15.762V18.834z" />
    </svg>
  )
}
